import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.CancelOrderModal
*
* Encapsulates the functionality of a modal dialog that cancels an order.
**/
HSN.CancelOrderModal = (function (parent) {
    __extends(CancelOrderModal, parent);
        
    function CancelOrderModal() {
        /** new HSN.CancelOrderModal() **/
        var modal = CancelOrderModal.__super__.constructor.call(this);

        this.Close.off();//remove existing handler, have our own
        this.accountService = HSN.Instance()._getAccountService();
            
        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        var scope = modal;
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });
        $(modal.Content).on('click', '#yes-cancel', function () {
            HSN.SetWait();
            var cancelReason = $('.cancel-reason', modal.Content).val();
            scope.accountService.CancelOrder({ orderIdentity: scope.orderIdentity, cancelReason: cancelReason }, {
                callback: function (data) {
                    if (data.success) {
                        if (scope.cancelCallback) {
                            HSN.RemoveWait();
                            closeModal(modal);
                            scope.cancelCallback();
                        }
                        else {
                            window.location.reload();
                        }
                    }
                    else {
                        HSN.HandleAjaxError(modal.Content, data, 'Unfortunately there was an error cancelling your order, please try again.');
                    }
                },
                errorCallback: function () {
                    HSN.RemoveWait();
                    alert('Unfortunately there was an error cancelling your order, please try again.');
                },
                scope: this
            });
            return false;
        });
        $(modal.Content).on('click', '#no-cancel', function () {
            closeModal(modal);
            return false;
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    /**
    * HSN.CancelOrderModal#Show() -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    CancelOrderModal.prototype._show = function (config) {
        var scope = this;

        scope.productTopLine = config.productTopLine;
        scope.showPromoCancelMessage = config.showPromoCancelMessage;
        scope.isAutoshipOrder = config.isAutoshipOrder;
        scope.orderIdentity = config.orderIdentity;
        scope.cancelCallback = config.cancelCallback;

        var modalContent = '<div class="account-container cancel-modal">';
        modalContent += '<div class="module">';
        modalContent += '<div class="header">ARE YOU SURE?</div>';
        modalContent += '<div class="description">Do you want to remove the <strong>' + scope.productTopLine + '</strong> from your order?</div>';
        if (scope.showPromoCancelMessage) {
            modalContent += '<div class="promo-description">Cancellation may disqualify your savings on a previous order. </div>';
        }
        if (scope.isAutoshipOrder) {
            modalContent += '<label for="cancel-reason">Please select your reason for canceling</label>';
            modalContent += '<select id="cancel-reason" class="cancel-reason" name="cancelReason">';
            modalContent += '<option>Choose a reason</option>';
            modalContent += '<option value="OrderedWrongItem">I ordered the wrong item</option>';
            modalContent += '<option value="ChangedMind">I\'ve changed my mind</option>';
            modalContent += '<option value="CoordinatingItemSoldOut">The coordinating item sold out</option>';
            modalContent += '<option value="UnsatisfiedExperience">I\'m not satisfied with my HSN experience</option>';
            modalContent += '<option value="Other">other</option>';
            modalContent += '</select>';
        }
        modalContent += '<div id="yes-cancel" class="submit-button main-button blue">YES, CANCEL ITEM</div>';
        modalContent += '<div id="no-cancel" class="submit-button main-button white">NO, DO NOT CANCEL</div>';
        modalContent += '</div>';
        modalContent += '</div>';

        scope.Root.removeClass('loading');
        scope.Content.showHtml(
            modalContent,
            0,
            function () {
                scope.Center();
                scope.Content.animate({ opacity: 1 });
            },
            function () {
            }
        );

        HSN.DataLayer.helpers.elementInteraction(null, "Modal", "Cancel Item");
    };
    return CancelOrderModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/MyAccount/CancelOrderModal.js